import Avatar from '@fuegokit/react/components/Avatar'
import sx from '@fuegokit/react/sx'
import themeGet from '@fuegokit/react/utils/theme-get'
import styled from 'styled-components'

export const StyledAvatar = styled(Avatar)`
  // ensures image/fallback is centered
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  // ensures image doesn't bleed out
  overflow: hidden;
  // ensures no selection is possible

  user-select: none;
  width: 48px;
  height: 48px;
  border-radius: 100%;
  background-color: ${themeGet('colors.background.neutral.bold.default')};
  ${sx}
`
export const StyledAvatarImage = styled(Avatar.Image)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: inherit;
  ${sx}
`
export const StyledAvatarFallback = styled(Avatar.Fallback)`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  //
  background-color: ${themeGet('colors.background.accent.teal.bolder')};
  color: ${themeGet('colors.text.inverse')};
  font-size: 16px;
  line-height: 1;
  font-weight: 500;
  ${sx}
`
